import React from 'react';

import { useNavigate } from 'react-router-dom';

import { LoyaltyTimCard } from 'components/app-header/loyalty/tim-card';
import { BackArrowHistory } from 'components/navigation/back-arrow';
import useAuthRedirects from 'hooks/auth/use-auth-redirects';

import { ScanContainer } from './styled';

const ScanTimCard = () => {
  const navigate = useNavigate();
  useAuthRedirects();
  return (
    <ScanContainer data-testid="loyalty-tim-card-page">
      <BackArrowHistory />
      <LoyaltyTimCard onDismiss={() => navigate('/')} />
    </ScanContainer>
  );
};

export default ScanTimCard;
